import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import { getConfig, setConfig } from '@constants';

import { EError } from '@enums';

import {
	Log,
	WindowVisibility,
} from '@utils';

import { CountersStore, ShowcaseStore, UiStore, AppsByGenreStore, AppsStore, CurrentUserStore } from '@stores';

import { IRouteConfigComponent } from '@interfaces';

export interface IAppBaseProps extends RouteComponentProps {

}

interface IAppRenderProps {
	error: string;
}

interface IAppProps extends IAppBaseProps {
	routes: IRouteConfigComponent[];
	render(renderProps: IAppRenderProps): React.ReactNode;
}

export interface IAppState {
	appsInstalledStore: AppsStore;
	appsByIdStore: AppsStore;
	appsNewStore: AppsStore;
	appsPopularStore: AppsStore;
	appsSalesStore: AppsStore;

	appsByGenreStore: AppsByGenreStore;
	showcaseStore: ShowcaseStore;
	currentUserStore: CurrentUserStore;
	uiStore: UiStore;
	countersStore: CountersStore;
	error: string;
}

// eslint-disable-next-line import/no-unused-modules
export class App extends React.Component<IAppProps, IAppState> {

	state: IAppState = {
		appsInstalledStore: null,
		appsByIdStore: null,
		appsNewStore: null,
		appsPopularStore: null,
		appsSalesStore: null,
		appsByGenreStore: null,
		showcaseStore: null,
		currentUserStore: null,
		uiStore: null,
		countersStore: null,
		error: null,
	};

	static getDerivedStateFromError() {
		return {
			error: EError.APP_ERROR,
		};
	}

	static getDerivedStateFromProps(nextProps: Readonly<IAppProps>, prevState: Readonly<IAppState>) {
		const {
			isError403,
			isError404,
			isError500,
			isError502,
		} = getConfig();
		const { error: prevError } = prevState;

		if (prevError === EError.APP_ERROR) {
			return null;
		}

		const error = (isError403 && EError.FORBIDDEN) ||
			(isError404 && EError.PAGE_NOT_FOUND) ||
			(isError500 && EError.INTERNAL_SERVER_ERROR) ||
			(isError502 && EError.BAD_GATEWAY) ||
			null;

		if (error) {
			Log.error(`Error: ${error}`);
		}

		return {
			error,
		};
	}

	componentDidMount(): void {
		const { location: { pathname, search } } = this.props;

		WindowVisibility.init();
		WindowVisibility.onChange(this.onVisibilityChange);

		Log.message(`Start app on ${pathname}?${search}`);
	}

	componentWillUnmount(): void {
		WindowVisibility.destroy();
	}

	componentDidUpdate(prevProps: Readonly<IAppProps>, prevState: Readonly<IAppState>): void {
		const {
			location: {
				pathname,
				search,
			},
		} = this.props;
		const {
			location: {
				pathname: prevPathname,
			},
		} = prevProps;
		const { error } = this.state;
		const { error: prevError } = prevState;

		if (pathname !== prevPathname) {
			if (error === EError.APP_ERROR && error === prevError) {
				this.clearError();
			}
			const isServerError = [
				EError.FORBIDDEN,
				EError.PAGE_NOT_FOUND,
				EError.INTERNAL_SERVER_ERROR,
				EError.BAD_GATEWAY,
			].includes(error as EError);

			if (isServerError && error === prevError) {
				this.clearServerError();
			}

			Log.message(`Navigate to ${pathname}?${search}`);
		}
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
		// intentionally left blank: default React logger is ok by now
	}

	clearError() {
		this.setState({ error: null });
	}

	clearServerError() {
		setConfig({
			...getConfig(),
			isError: false,
			isError403: false,
			isError404: false,
			isError500: false,
			isError502: false,
		});

		this.clearError();
	}

	onVisibilityChange = () => {
		// if (WindowVisibility.isVisible()) {
		// 	this.setTrackInterval();
		// } else {
		// 	this.clearTrackInterval();
		// }
	};

	render() {
		const { error } = this.state;

		return this.props.render({ error });
	}

}
